import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
    betSelectLabelWrapper: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        transition: "all ease-in 1s",
        "&.prolimit": {
            width: "0%",
            overflow: "hidden",
            transition: "all ease-in 1s",
        },
    },
    betSelectLabelIcon: {
        width: 24,
        height: 24,
        marginRight: 8,
    },
    betSelectLabel: {
        fontWeight: 700,
        fontSize: 24,
        color: "#F5F5F5E5",
        "&.prolimit": {
            width: "0%",
            overflow: "hidden",
            transition: "all ease-in 0.5s",
        },
    },
    betSelectIcon: {
        width: "100%",
        height: "100%",
        objectFit: "contain",
    },
    betOption: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        color: "rgba(245, 245, 245, 0.9)",
        padding: "9px 12px",
    },
    betOptionSelected: {
        color: "rgba(245, 245, 245, 0.9)",
        background: "rgba(105, 114, 128, 0.3)",
    },
    betDropdownOptionIcon: {
        width: 16,
        height: 16,
        opacity: 0.5,
        marginRight: 5,
    },
    betDropdownOptionIconSelected: {
        opacity: 1,
    },
    betDropdownOptionLabel: {
        fontSize: 16,
        fontWeight: 500,
        color: "rgba(245, 245, 245, 0.9)",
    },
});
